export default function formatAddress(address, type = 'long') {
  if (address && Array.isArray(address)) {
    let newAddress = [];

    const placeTypes = [
      'floor',
      'room',
      'route',
      'street_address',
      'street_number',
      'locality',
    ];

    switch (type) {
      case 'short':
        address.forEach((item) => {
          placeTypes.forEach(
            (type) =>
              item.types.includes(type) && newAddress.push(item.short_name)
          );
        });
        break;
      case 'long':
        address.forEach((item) => newAddress.push(item.short_name));
        break;
      case 'province':
        address.forEach((item) => {
          if (item.types.includes('administrative_area_level_1')) {
            newAddress.push(item.long_name);
          } else {
            item = { types: [] };
          }
        });
        break;
      default:
        break;
    }

    return newAddress.length ? newAddress.join(', ') : '';
  }

  if (typeof address === 'string' && type === 'short') {
    return address.split(',').slice(0, 3).join(', ');
  }
  return address;
}
